import Home from './pages/Home'

export default {
  routes: [
    {
      key: 'home',
      type: 'unauthorized',
      title: 'Home',
      path: `/`,
      component: Home,
      exact: true,
    },
  ],
}
